<section class="partners-section" #partnersSection>
  <div class="container">
    <h2 class="partners-title">Operamos con</h2>

    <div class="carousel-container" [class.visible]="isVisible">
      <div class="carousel-wrapper">
        <div class="carousel-track">
          <div class="carousel-slide" *ngFor="let slide of slides">
            <div class="partner-card" [class.featured-card]="slide.isFeatured">
              <img [src]="slide.src" [alt]="slide.alt">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>